<template>
  <v-dialog v-model="localDialog" width="35%" @update:modelValue="updateDialog" transition="" persistent :open-delay="0" :close-delay="0">
    <base-card
      :title="isEntryMode ? 'Add Designation' : 'Update Designation'"
      :v-card-text-class="'pa-4'"
    >
<v-form @submit.prevent="submit" ref="DesignationSetup">
              <v-row>
                  <v-col cols="12"> 
                      <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="department_id.value.value"
                          :items="getHrmDepartmentList"
                          :item-title="(item) => `${item.name}`"
                          item-value="id"
                          :error-messages="department_id.errorMessage.value"
                          autocomplete="off"
                          clearable

                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Department
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="employee_id.value.value"
                          :items="getHrmEmployeeList.filter(item => item.department_id === department_id.value.value)"
                          :item-title="(item) => `${item.name} - ${item.designation.name}`"
                          item-value="id"
                          :error-messages="employee_id.errorMessage.value"
                          autocomplete="off"
                          clearable

                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Employee
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                            label="Remarks"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            clearable
                        ></v-text-field>

                      <v-checkbox                            
                          label="Active"
                          v-model="status.value.value"
                          :error-messages="status.errorMessage.value"
                          density="compact"
                          variant="outlined"
                          hide-details
                          single-line
                          color="primary"
                          value="1"
                      ></v-checkbox>
                      <input v-model="hod_id.value.value" type="hidden">
                  </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </base-card>
  </v-dialog>
</template>

<script>
import baseCard from '@/components/utils/baseCard.vue';
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import { fileServerUrl } from "@/store/api";

export default {
  components: { baseCard },
  name: 'DepartmentSetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        remarks: '',
        status: 1,
        department_id: null,
        employee_id: null,
        id: '',
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
    }
  },
  computed: {
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    }
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.remarks.setValue(newData.remarks || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.employee_id.setValue(newData.employee_id || null, false);
        this.department_id.setValue(newData.department_id || null, false);
        this.hod_id.setValue(newData.id || '', false);
      },
    }

  },
  created() {
    // if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch('getHrmDepartmentList')
    // }

    // if (this.$store.getters.getHrmEmployeeList.length === 0) {
      this.$store.dispatch('getHrmEmployeeList')
    // }
  },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
        validationSchema: yup.object({
          department_id: yup.number().positive().integer().required().label('Department Name'),
          employee_id: yup.number().positive().integer().required().label('Designation Name'),
          remarks: yup.string().nullable().label('Remarks'),
        }),

    });

    const department_id = useField('department_id');
    const employee_id = useField('employee_id');
    const hod_id = useField('hod_id');
    const status = useField('status');
    const remarks = useField('remarks');
    const errorMessages = ref('');
    const loading  = ref('');
    const store = useStore();

     watch(() => department_id.value.value, () => {
      employee_id.value.value = null;
    });

    const submit = handleSubmit((values) => {

        store.dispatch("saveUpdateHrmHOD", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getHrmHODList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      remarks,
      status,
      errorMessages,
      employee_id,
      department_id,
      hod_id,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

